import dataSubjectInfo from './dataSubjectInfo'
import statusLabelColor from './statusLabelColor'
import ticketInfo from './ticketInfo'

const tickets = {
  dataSubjectInfo,
  statusLabelColor,
  ticketInfo,
}

export default tickets
